import AllMemberLevel from './AllMemberLevel';

export default (props) => {
  return <AllMemberLevel {...props} />;
};
